import { Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, Output, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ModalComponent, StoreService } from 'core/index';
import { KeplerFederationRankingListService } from './kepler-federation-ranking.service';

@Component({
  selector: 'lms-kepler-federation-ranking-list',
  templateUrl: './kepler-federation-ranking.component.html',
  styleUrls: ['./kepler-federation-ranking.component.scss'],
  providers: [KeplerFederationRankingListService]
})
export class KeplerFederationRankingListComponent implements OnChanges, OnDestroy {
  @Input() options: any;
  @Output() isAnySelectedChange = new EventEmitter<boolean>();
  @Output() openModal = new EventEmitter<boolean>();
  @Output() selectedFederationRankings = new EventEmitter<any>();

  @ViewChild('editFederation', { static: false }) public editFederation: ModalComponent;

  @ViewChild('federationsRankingTable', { static: false }) federationsRankingTable: ElementRef;

  public keplerRankingFederationListId = 'KEPLER_RANKING_FEDERATION_LIST';
  public items: any[];
  public dataSource: any;

  public isAnySelected = false;
  public selectable = true;
  public selectedFederations: any = [];
  public excludedFederations: any = new Set();
  public isHeaderSelectedAll: boolean = false;
  constructor(
    public translate: TranslateService,
    public keplerRankingFederationTableListService: KeplerFederationRankingListService
  ) {}

  async ngOnChanges() {
    const listOptions = {
      ...this.options,
      selectionHandler: (data) => this.selectionHandler(data)
    };
    this.dataSource = await this.keplerRankingFederationTableListService.getDatasource(
      this.keplerRankingFederationListId,
      listOptions
    );
  }

  ngOnDestroy() {
    StoreService.remove(this.keplerRankingFederationListId);
  }

  onDatasourceUpdate() {
    this.setSelectAll(false);
    StoreService.update(this.keplerRankingFederationListId, this.dataSource);
  }

  addFederation() {
    this.openModal.emit(true);
  }

  setCollection(collection) {
    this.items = collection;
  }

  onFiltersChanged(): void {
    this.setSelectAll(false);
  }

  setSelectAll(flag): void {
    this.excludedFederations.clear();
    this.dataSource.selectionHandler = flag ? (data) => this.selectionHandler(data) : null;
    this.isAnySelected = flag;
    this.selectedFederations = flag ? this.dataSource.docs : [];
    this.selectedFederationRankings.emit(flag ? this.dataSource.docs : []);
    this.isHeaderSelectedAll = flag;
    this.federationsRankingTable.nativeElement.setAllSelected(flag);
    this.isAnySelectedChange.emit(this.isAnySelected);
  }
  onRowSelectionChanged(eventDetail): void {
    const { selected, data } = eventDetail;
    if (selected) {
      this.excludedFederations.delete(data.position);
    } else {
      this.excludedFederations.add(data.position);
    }
  }

  onSelectionChanged(selection): void {
    const { selected = [], isSelectedAll = false } = selection || {};
    this.selectedFederations = selected;
    if (isSelectedAll && !this.isHeaderSelectedAll) {
      this.excludedFederations.clear();
      this.selectedFederations = this.dataSource.docs;
    }
    if (!isSelectedAll && this.isHeaderSelectedAll) {
      this.isHeaderSelectedAll = false;
    }
    this.isAnySelected = this.selectedFederations && this.selectedFederations.length ? true : false;
    this.selectedFederationRankings.emit(this.selectedFederations);
    this.isAnySelectedChange.emit(this.isAnySelected);
  }

  selectionHandler(rowData) {
    if (rowData) {
      if (this.excludedFederations.has(rowData.position)) return false;
      return (
        this.isHeaderSelectedAll ||
        (this.selectedFederations && this.selectedFederations.some((license) => license.position === rowData.position))
      );
    }
    return this.isHeaderSelectedAll;
  }
}
